module.exports = __webpack_public_path__ + "img/php.83fd7bd0.png";